// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:1024px){.container-size-small[data-v-21a3abce]{width:30%}.container-size-medium[data-v-21a3abce]{width:50%}.container-size-large[data-v-21a3abce]{width:80%}.container-size-no-size[data-v-21a3abce]{width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
